<div class="Component {$state ? 'Minimized' : ''}">
  {#if $state}
    <Minimized {menu} bind:minimized="{minimized}" {before}>
      <span slot="after"><slot minimized={true} name="after"/></span>
    </Minimized>
  {:else}
    <Maximized {menu} {title} {subtitle} bind:minimized="{minimized}" {before}>
      <span slot="after"><slot maximized={true} name="after"/></span>
    </Maximized>
  {/if}
</div>


<script>
  import Maximized from './NavigationMaximized.svelte';
  import Minimized from './NavigationMinimized.svelte';
  import { createNavState } from 'root/components/organisms/SideNavigation/SideNavigationPinService.js';

  export let id;
  export let title = '';
  export let subtitle = '';
  export let menu = [];
  export let before;

  const state = createNavState(id);
  let minimized = $state;
  $: updatePinned(minimized);

  function updatePinned(value){
    state.setPinned(value);
  }
</script>

<style lang="stylus">
  @import './styles.blocks.styl';

  .Component {
    {Component}


    &.Minimized {
      max-width: 48px;
    }
  }
</style>
